export default __webpack_public_path__ + "static/media/IF_MyTeamStrengths_Small.f8590c85.jpg";